import { Log, PaginatedLogs } from '@app/modules/shared/models';

export interface ILogsState {
  log: Log;
  logs: Log[];
  paginatedLogs: PaginatedLogs;
  success: string;
  error: string;
}

export const initialLogsState: ILogsState = {
  log: null,
  logs: [],
  paginatedLogs: null,
  success: '',
  error: ''
};
